import type { UUID } from '@cmg/common';
import { Button } from '@cmg/design-system';
import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import routeFactory from '../../../../common/util/routeFactory';
import { PageGridSection } from '../../../../design-system/body-sections/PageGridSection';
import { IdentityPageContent } from '../../../../design-system/IdentityPageContent';
import { SalesCoverageGrid } from './components/SalesCoverageGrid/SalesCoverageGrid';

export function CRMSalesCoverageRoute() {
  const navigate = useNavigate();

  const { crmIntegrationId } = useParams<{ crmIntegrationId?: UUID }>();

  const handleAddEmployee = useCallback(() => {
    if (crmIntegrationId) {
      navigate(routeFactory.sysAdminCrmSalesCoverageEmployeeNew.getUrlPath({ crmIntegrationId }));
      return;
    }
    navigate(routeFactory.customerCrmSalesCoverageEmployeeNew.getUrlPath());
  }, [navigate, crmIntegrationId]);

  return (
    <IdentityPageContent
      slotProps={{ grid: { height: '100%' } }}
      gridContent={
        <PageGridSection
          slotProps={{ stack: { height: '100%' } }}
          size="large"
          title="Sales Coverage"
          actions={
            <Button variant="contained" onClick={handleAddEmployee}>
              Add Employee
            </Button>
          }
          content={<SalesCoverageGrid tenantId={crmIntegrationId} />}
        />
      }
    />
  );
}
